import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Button, Select, Text } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { useCustomViewAttributesStore } from "./CustomViewAttributesStore";

const AttributesLevel: FunctionComponent = observer(() => {
	const attributesStore = useCustomViewAttributesStore();
	const {
		levelOptions,
		onChangeLevel,
		onClickMatrixContainerBack,
		selectedLevelOption,
		selectedMatrixContainer,
	} = attributesStore;

	if (selectedMatrixContainer) {
		return (
			<>
				<Button
					design="link"
					onClick={onClickMatrixContainerBack}
					size="small"
					startIcon={<ArrowBackIcon />}
				>
					<Text
						res="Back"
						semiBold
					/>
				</Button>
				<Text
					lineHeight={26}
					res="CustomViewAttributesType"
					resParams={[selectedMatrixContainer.name]}
					semiBold
				/>
			</>
		);
	}

	if (levelOptions.length > 1) {
		return (
			<>
				<Text
					flexShrink="0"
					res="CustomViewAttributesLevel"
					semiBold
				/>
				<Select
					items={levelOptions}
					onChange={onChangeLevel}
					value={selectedLevelOption.id}
				/>
			</>
		);
	}

	return (
		<Text
			lineHeight={26}
			res="CustomViewAttributesType"
			resParams={[selectedLevelOption.name]}
			semiBold
		/>
	);
});

export default AttributesLevel;